import _ from 'lodash'

class AuthService {
  constructor(
    $http,
    $cookies,
    $log,
    $location,
    config,
    $window,
    AccessToken,
    User,
    CurrentUserService,
    AnalyticsUserPropertiesService,
    $analytics
  ) {
    this.$log = $log
    this.$http = $http
    this.$cookies = $cookies
    this.$location = $location

    this.$window = $window
    this.user = null
    this.jwt = null

    this.CurrentUserService = CurrentUserService
    this.AnalyticsUserPropertiesService = AnalyticsUserPropertiesService
    this.$analytics = $analytics

    this.User = User
    this.AccessToken = AccessToken

    this.accountUrl = config.accountEndpoint + "/user"
    this.authUrl = config.authenticationEndpoint + "/token"
    this.config = config
    this.authCookie = 'ose-token'
    this.authToken = 'ose-token'
    this.authHeader = 'X-AUTH-TOKEN'

    this._setToken()
  }

  get currentUser() {
    return this.CurrentUserService.current
  }

  get currentUserId() {
    return this.CurrentUserService.current.userId
  }

  get userRoles() {
    return this.CurrentUserService.roles
  }

  get loggedIn() {
    return !!this.jwt && this._jwtActive(this.jwt)
  }

  login(credentials, successCallback, failureCallback) {
    this.AccessToken.login(
      credentials,
      response => {
        this._setToken(response.token)
        this._getAccountDetails(this.jwt, successCallback, failureCallback)
      },
      response => this._onLoginFailure(response, failureCallback))
  }

  logout() {
    this.AccessToken.logout(
      {appName: this.config.appName},
      response => {
        this._performClientLogout()
      },
      response => {
        this._performClientLogout()
        this._onLogoutFailure(response)
      }
    )
  }

  _performClientLogout() {
    this._revokeToken()
    this.CurrentUserService.logout()
  }

  _getAccountDetails(jwt, successCallback, failureCallback) {
    var userId = this._userIdFromJwt(jwt)
    if (!_.isNull(userId)) {
      this.User.get(
        {id: userId},
        response => this._onLoginSuccess(response, successCallback),
        response => this._onLoginFailure(response, failureCallback)
      )
    } else {
      failureCallback({})
    }
  }

  _onLoginSuccess(response, callback = function() {}) {
    this.CurrentUserService.login(response.user)
    this.AnalyticsUserPropertiesService
      .sendUserProperties(this.CurrentUserService.current)
    this.AnalyticsUserPropertiesService.gatherAndSendUserSubscription()
    this.$analytics.eventTrack('Logged In')

    try {
      this.$analytics.people.setOnce(JSON.parse(localStorage['__referrer']))
    } catch (e) {
      console.log('Cannot set referrer', e);
    }
    callback(response)
  }

  _onLoginFailure(response, callback = function() {}) {
    this.$log.debug(
      'failed login',
      {
        environment: this.config.environment,
        data: response.data,
        status: response.status,
        statusText: response.statusText,
        headers: response.config.headers,
        method: response.config.method,
        email: response.config.data.email
      }
    )

    callback(response)
  }

  _onLogoutFailure(response) {
    this.$log.debug('failed logout on server', response)
  }

  //originally this function would set the token from the stored cookie, but
  //we are moving away from cookies and instead have the jwt returned in the response body.
  //for now we are going to check both to make sure there are no compatibility issues if
  //the needed release doesn't happen in parallel.
  _setToken(jwt) {
    //TODO refactor after next release is stable (2/24/16)
    if(jwt){
      this.jwt = jwt
      localStorage.setItem(this.authToken, jwt)
    } else {
      this.jwt = localStorage.getItem(this.authToken)
    }
    if (!this.jwt) {
      this.jwt = this.$cookies.get(this.authCookie);
    }
    this.$http.defaults.headers.common[this.authHeader] = this.jwt
  }

  _revokeToken() {
    this.$cookies.remove(
      this.authCookie,
      { path: '/', domain: '.oseberg.io' }
    )
    localStorage.removeItem(this.authToken)
    this._setToken()
  }

  _jwtActive(jwt) {
    var exp = this._parseJwt(jwt).exp
    var now = Math.round(new Date().getTime() / 1000)
    return now <= exp
  }

  _userIdFromJwt(jwt) {
    return (!_.isNull(jwt) && typeof jwt != 'undefined'
      ? this._parseJwt(jwt).user_id : null)
  }

  _parseJwt(jwt) {
    var base64Url = jwt.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(this.$window.atob(base64));
  }
}

AuthService.$inject = [
  '$http',
  '$cookies',
  '$log',
  '$location',
  'config',
  '$window',
  'AccessToken',
  'User',
  'CurrentUserService',
  'AnalyticsUserPropertiesService',
  '$analytics'
]

export default AuthService
